export enum EmailVerificationStepName {
  LANDING= 'landing',
  VERIFY_OTP= 'verifyOtp',
  SUCCESS = 'success',
}


export interface EmailVerificationStep {
  stepName: EmailVerificationStepName;
  error?: string;
  isEditable?: boolean;
  sendOtpExhausted?: boolean;
  otpId?: string;
  email?: string;
}


export interface EmailVerificationState {
  steps: EmailVerificationStep[];
  suggestedMobileNumber?: string;
  flowDisabled: boolean;
  mobileNumberList?: string[];
}


export interface ErrorInApi {
  messageToDisplay?: string;
  errorToLog: string;
}

// * SEND EMAIL MAPPING OTP
export enum SendMappingOTPError {
  INVALID_TOKEN = 'invalidToken',
  INVALID_LOGIN_METHOD = 'invalidLoginMethod',
  NETWORK_ERROR = 'networkError',
  RATE_LIMIT = 'suspiciousOrRateLimited',
  OTHER_ERROR = 'otherErrors',
  RETRIES_EXHAUSTED = 'retriesExhausted',
}


export interface SendMappingOtpErrorInApi extends ErrorInApi {
  type: SendMappingOTPError;
}


export enum SendMappingOTPStatus {
  SUCCESS = 'success',
  RETRIES_EXHAUSTED = 'retriesExhausted',
  OTHERS = 'other',
}


export interface SendMappingOTPResponse {
  error?: SendMappingOtpErrorInApi;
  status?: SendMappingOTPStatus;
  isEditable?: boolean;
  message?: string;
  otpId?: string;
  retriesLeft?: number;
}


export enum VerifyMappingOtpStatus {
  SUCCESS = 'success',
  RETRIES_EXHAUSTED = 'retriesExhausted',
  ERROR = 'error',
}

export enum VerifyMappingOtpError {
  AUTHENTICATION_FAILED = 'authenticationFailed',
  VERIFICATION_FAILED = 'otpVerificationFailed',
  EXHAUSTED_VERIFY_ATTEMPTS = 'verifyTriesExceeded',
  NETWORK_ERROR = 'networkError',
  OTHER = 'otherError',
}

export interface VerifyMappingOtpErrorInApi extends ErrorInApi {
  type: VerifyMappingOtpError;
}

export interface VerifyMappingOtpResponse {
  error?: VerifyMappingOtpErrorInApi;
  status?: VerifyMappingOtpStatus;
  message?: string;
}


export interface SendEmailOtpRequestParams {
  email?: string;
  otpId?: string;
}
